import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Search as SearchIcon } from 'lucide-react';
import api from '../utils/api';

const SearchPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('q') || '');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (query) handleSearch();
  }, []);

  const handleSearch = async (e) => {
    if (e) e.preventDefault();
    if (!query.trim()) return;
    
    setSearchParams({ q: query });
    setLoading(true);
    try {
      const response = await api.get(`/products?search=${encodeURIComponent(query)}&status=published`);
      setResults(response.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FFFDF9] py-12">
      <div className="container mx-auto px-4 md:px-8">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#2A0000] mb-8">Search Products</h1>
        
        <form onSubmit={handleSearch} className="mb-12 max-w-2xl">
          <div className="flex space-x-2">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search by name, SKU, category, or color..."
              className="flex-1 px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-[#E5A93C]"
              data-testid="search-input"
              autoFocus
            />
            <button type="submit" className="btn-primary flex items-center space-x-2" data-testid="search-submit">
              <SearchIcon className="w-5 h-5" /><span>Search</span>
            </button>
          </div>
        </form>

        {loading ? (
          <p className="text-center text-gray-600 py-12">Searching...</p>
        ) : query && results.length === 0 ? (
          <p className="text-center text-gray-600 py-12">No results found for "{query}"</p>
        ) : results.length > 0 ? (
          <>
            <p className="text-gray-600 mb-6">Found {results.length} result{results.length !== 1 ? 's' : ''}</p>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {results.map(p => (
                <Link key={p.sku} to={`/product/${p.sku}`} className="product-card p-3 group">
                  <img
                    src={(p.images && p.images[0]) || 'https://images.pexels.com/photos/10317127/pexels-photo-10317127.jpeg'}
                    alt={p.title}
                    className="w-full h-72 object-cover mb-3 group-hover:scale-105 transition-transform"
                  />
                  <h3 className="font-semibold text-sm text-[#2C2C2C]">{p.title}</h3>
                  <p className="text-xs text-gray-600">{p.sku} • {p.color}</p>
                  <p className="font-bold text-[#E5A93C]">₹{p.price}</p>
                </Link>
              ))}
            </div>
          </>
        ) : (
          <p className="text-center text-gray-600 py-12">Enter a search term to find products</p>
        )}
      </div>
    </div>
  );
};

export default SearchPage;
